import React, { useCallback } from 'react';
import {getNid} from "../../wui-core/src/index"
import { TabProps } from './iTabs'

const Tab: React.FC<TabProps> = (props) => {
    const { clsfix, children, active = false, tabClick, onClick, value } = props;
    const click = useCallback(() => {
        tabClick?.(value as string);
        onClick?.(value as string);
    }, [tabClick, onClick, value]);
    return (
        <span className={`${clsfix}-item${active ? ' active' : ''}`} onClick={click} {...getNid(props)}>
            {children}
        </span>
    );
};

export default Tab;
